var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.alternative)?_c('Header'):_vm._e(),(_vm.loading)?_c('Loading'):[_vm._t("default")],(!_vm.alternative)?_c('Footer'):_vm._e(),(!_vm.alternative)?_c('FixedApps'):_vm._e(),_c('CookieBanner')],2)}
var staticRenderFns = []

export { render, staticRenderFns }